import { useQuery } from "@tanstack/react-query";
import { AXIOS_RESERVATION } from "../utils/axios-interceptors";
import { IUseGetCouponTypesQueryResponse } from "../utils/types";

const useGetCouponTypesQuery = (data?: any): IUseGetCouponTypesQueryResponse =>
  useQuery({
    queryKey: ["coupon-types"],
    queryFn: async () => {
      const response = await AXIOS_RESERVATION.get("v1/coupons/types", {params: data});
      return response.data;
    },
  });

export default useGetCouponTypesQuery;
